module.exports = __webpack_public_path__ + "static/media/26.61740480.jpg";